import React from 'react'
import { Alert, } from 'reactstrap'

export default function CurrentQuestionAlert({
  answersByItem, 
  user, 
  selectedStudent, 
  selectedAnswer,
  isGroup,
  activeItem
}) {
  if (user) {
    const showAlertQ = !!((!answersByItem && user.role !== 'Student') ||
                        (selectedStudent && !selectedAnswer))
    if (showAlertQ) {
      let text = 'This student has not answered this item.'
      if (isGroup && !selectedStudent) {
        text = 'No selected students have answered this item.'
        if (!activeItem) {
          text = 'No selected students have completed this test.'
        }
      }
      return (
        <Alert color='warning'>
          {text}
        </Alert>
      )
    } else return null
  } else return null
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessTest/AssessTestComponents/CurrentQuestionAlert.js